import React, { useState, useRef, useEffect } from "react";
import axios from "axios"
const ChatInput = ({ onGenerate, input, setInput, selectedIndustry  }) => {
  const [isRecording, setIsRecording] = useState(false);
  const inputRef = useRef(null);
  let recognition = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [mockSuggestions, setMockSuggestions] = useState([]) 
  const speechEndTimeout = useRef(null);
  const toggleSuggestions = () => {
    setShowSuggestions(!showSuggestions);
  };

  useEffect(() => {
    // Fetch suggestions based on the selected industry
    let selectedIndustryPrompt
    if (selectedIndustry === "All") {
      selectedIndustryPrompt = "Across the internet";
    } else if (selectedIndustry === "faq") {
      selectedIndustryPrompt = "Accenture Specific";
    } else if (selectedIndustry === "consumer") {
      selectedIndustryPrompt = "Consumer Goods and Services";
    } else if (selectedIndustry === "measurement") {
      selectedIndustryPrompt = "Sustainability Measurement";
    } else if (selectedIndustry === "valueChain") {
      selectedIndustryPrompt = "Sustainable Value Chain";
    } else {
      selectedIndustryPrompt = selectedIndustry;
    }
   
  }, [selectedIndustry]);

  // Filter suggestions based on the input provided
  useEffect(() => {
    if (input.trim()) {
      const filteredSuggestions = mockSuggestions
        .map((suggestion) => suggestion.Prompt)
        .filter((prompt) =>
          prompt.toLowerCase().includes(input.toLowerCase())
        );
      setSuggestions(filteredSuggestions);
    } else {
      setSuggestions(mockSuggestions.map((suggestion) => suggestion.Prompt));
    }
  }, [input, mockSuggestions]);

 
 

  const handleMicClick = () => {
    if (isRecording) {
      recognition.current.stop();
      return;
    }

    recognition.current = new (window.SpeechRecognition ||
      window.webkitSpeechRecognition)();
    recognition.current.continuous = false;
    recognition.current.interimResults = false;
    recognition.current.lang = "en-US";

    recognition.current.onstart = () => {
      console.log(
        "Voice recognition started. Try speaking into the microphone."
      );
      setIsRecording(true);
    };

    recognition.current.onspeechend = () => {
      console.log(
        "You were quiet for a while so voice recognition turned itself off."
      );
      speechEndTimeout.current = setTimeout(() => {
        if (isRecording) {
          recognition.current.stop();
        }
      }, 5000); // Wait for 3 seconds
    };

    recognition.current.onresult = (event) => {
      clearTimeout(speechEndTimeout.current);
      const transcript = event.results[0][0].transcript;
      console.log("Result received: " + transcript);
      setInput(transcript);
      setIsRecording(false);
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    recognition.current.onerror = (event) => {
      console.error("Error occurred in recognition: " + event.error);
      clearTimeout(speechEndTimeout.current);
      setIsRecording(false);
    };

    recognition.current.onend = () => {
      setIsRecording(false);
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    recognition.current.start();
  };

  const handleSend = () => {
    if (input.trim()) {
      onGenerate(input);
      setInput("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: "2px" }}
      className="container-fluid input-group mb-3"
    >
      <div className="d-flex align-items-center" style={{ flex: 7 }}>
        <div id="inputmessage" style={{ width: "100%" }}>
          <textarea
            ref={inputRef}
            className="form-control"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type your message..."
            id="input-div-id"
            maxLength={400}
            style={{
              height: "auto",
              minHeight: "6rem",
              overflow: "auto",
              resize: "none",
            }}
          />
        
        </div>
      </div>
      <div
        className="d-flex justify-content-end align-items-center"
        style={{ flex: 1 }}
        id="icons-div"
      >
        <div className="input-group-append">
          <span className="input-group-text bg-white border-0">
            <i
              className={`bi ${
                isRecording ? "bi-record-circle-fill" : "bi-mic-fill"
              }`}
              id="mic-icon-div"
              onClick={handleMicClick}
              style={{ fontSize: "2.5rem", cursor: "pointer" }}
            ></i>
          </span>
        </div>
      </div>
     
      {/* {input.trim() && ( */}
      <div className="d-flex align-items-center" style={{ flex: 1 }}>
        <button
          className="btn btn-primary ai-coach-button"
          onClick={handleSend}
          disabled={!input.trim()}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatInput;
